const FAAS_DECISION = {
  APPROVED: 'APPROVED',
  DECLINED: 'DECLINED',
  REVIEW: 'REVIEW',
  NONE: 'NONE'
}

export default FAAS_DECISION
